/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Delete_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "Please enable compliance in settings to delete pattern templates." |
*
* @param {Compliance_Delete_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_delete_disabled_desc = /** @type {((inputs?: Compliance_Delete_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Delete_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte aktiviere Compliance in den Einstellungen, um Muster-Vorlagen zu löschen.")
	return /** @type {LocalizedString} */ ("Please enable compliance in settings to delete pattern templates.")
});